import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './8ecdaace970cdd77cf074520896836fa37bde88f026b2c2fd3a8660dca26aea8.cfe-internal.js';
import { useInputGroupContext } from '../InputGroup/cd290dc9875526bf8b4a87c532dd848f47a3d87c6c746e77ffaa6cdb173c3440.cfe-internal.js';
import { useFormFieldContext } from '../FormField/ff8bdfb918b98e400d01f1272050447aed13a9c7dbe824884d42b110edddae42.cfe-internal.js';
import concatIds from '../../utils/concatIds/4f58d37595ecc5912f64ecb84828b103f66a43e895e850434f09170560f4b3d7.cfe-internal.js';

var _excluded = ["className", "value", "defaultValue", "disabled", "full", "invalid", "multiline", "onChange", "rows", "small", "type", "aria-describedby", "readOnly"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context, _context2; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(source), !0)).call(_context, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var Input = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _classNames;

  var className = _ref.className,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$full = _ref.full,
      full = _ref$full === void 0 ? false : _ref$full,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      multiline = _ref.multiline,
      onChange = _ref.onChange,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 2 : _ref$rows,
      _ref$small = _ref.small,
      small = _ref$small === void 0 ? false : _ref$small,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      externalAriaDescribedBy = _ref['aria-describedby'],
      readOnly = _ref.readOnly,
      rest = _objectWithoutProperties(_ref, _excluded);

  var inputGroupContext = useInputGroupContext();

  var _useFormFieldContext = useFormFieldContext(),
      formFieldHelperTextId = _useFormFieldContext.helperTextId,
      formFieldErrorTextId = _useFormFieldContext.errorTextId,
      formFieldIsReadOnly = _useFormFieldContext.isReadOnly;

  var internalAriaDescribedby = concatIds(externalAriaDescribedBy, formFieldHelperTextId, formFieldErrorTextId);
  var classes = classNames(styles.input, inputGroupContext.className, inputGroupContext.inputClassName, (_classNames = {}, _defineProperty(_classNames, styles.full, inputGroupContext.applyFull(full)), _defineProperty(_classNames, styles.invalid, invalid), _defineProperty(_classNames, styles.small, inputGroupContext.applySmall(small)), _defineProperty(_classNames, styles.multiline, multiline), _classNames), className);

  var commonProps = _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    className: classes,
    disabled: disabled,
    defaultValue: defaultValue,
    'aria-invalid': invalid,
    onChange: disabled ? null : onChange,
    value: value,
    'aria-describedby': internalAriaDescribedby,
    readOnly: readOnly !== null && readOnly !== void 0 ? readOnly : formFieldIsReadOnly
  });

  return multiline ? /*#__PURE__*/React__default.createElement("textarea", _extends({}, commonProps, {
    rows: rows
  })) : /*#__PURE__*/React__default.createElement("input", _extends({}, commonProps, {
    type: type
  }));
});
var Input$1 = Input;

export { Input$1 as default };
